import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Tabs, Tab } from "@mui/material";

const StatBox = ({ value, label }) => (
  <div style={{ textAlign: "center", margin: "10px", flex: 1 }}>
    <div style={{ fontSize: "24px", fontWeight: "600" }}>{value ?? "-"}</div>
    <div style={{ fontSize: "10px", color: "#555", marginTop: "4px" }}>{label}</div>
  </div>
);

const RankRow = ({ rank, name, image, isActor }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "6px 0" }}>
    <div style={{ width: 18, textAlign: "right", fontSize: 11, color: "#aaa", flexShrink: 0 }}>
      #{rank}
    </div>
    {image ? (
      <img
        src={image}
        alt={name}
        style={
          isActor
            ? { width: 36, height: 36, borderRadius: "50%", objectFit: "cover", flexShrink: 0, boxShadow: "0 1px 4px rgba(0,0,0,0.15)" }
            : { width: 26, height: 39, borderRadius: 4, objectFit: "cover", flexShrink: 0, boxShadow: "0 1px 4px rgba(0,0,0,0.15)" }
        }
      />
    ) : (
      <div
        style={
          isActor
            ? { width: 36, height: 36, borderRadius: "50%", background: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }
            : { width: 26, height: 39, borderRadius: 4, background: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }
        }
      >
        {isActor ? "🎭" : "🎬"}
      </div>
    )}
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 12, fontWeight: 600, lineHeight: 1.3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</div>
    </div>
  </div>
);

export function StatsModal({ open, onClose, userStats, reelStats, topActorAndMovie, universalStats }) {
  const [tab, setTab] = useState(0);
  const hasTop = topActorAndMovie && (topActorAndMovie.actors?.length > 0 || topActorAndMovie.movies?.length > 0);

  return (
    <Dialog open={open} onClose={onClose} TransitionProps={{ onExited: () => setTab(0) }}>
      <DialogTitle
        style={{
          fontFamily: "'Montserrat'",
          fontWeight: "700",
          fontSize: "22px",
          textAlign: "center",
          paddingBottom: 0,
        }}
      >
        Stats
      </DialogTitle>

      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        centered
        sx={{
          minHeight: 36,
          "& .MuiTab-root": { fontFamily: "'Montserrat'", fontSize: 11, fontWeight: 600, minHeight: 36, textTransform: "none", padding: "6px 16px" },
          "& .MuiTabs-indicator": { backgroundColor: "#000" },
          "& .Mui-selected": { color: "#000 !important" },
        }}
      >
        <Tab label="My Stats" />
        <Tab label="Reely Stats" />
      </Tabs>

      <DialogContent
        style={{
          overflowX: "hidden",
          padding: "16px",
          maxWidth: "100vw",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            fontFamily: "'Montserrat'",
            fontSize: "13px",
            lineHeight: "1.6",
            width: "320px",
            maxWidth: "100%",
            margin: "0 auto",
          }}
        >
          {tab === 0 && (
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <StatBox value={userStats?.total_reels_completed} label="Total Reels" />
                <StatBox value={userStats?.current_streak} label="Current Streak" />
                <StatBox value={userStats?.longest_streak} label="Longest Streak" />
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                <StatBox value={reelStats?.avg?.toFixed(1)} label="Average Reel Length" />
                <StatBox value={reelStats?.min} label="Shortest Reel" />
                <StatBox value={reelStats?.max} label="Longest Reel" />
              </div>

              {hasTop && (
                <>
                  <hr style={{ margin: "20px 0 16px", border: "none", borderTop: "1px solid #eee" }} />
                  {topActorAndMovie.actors?.length > 0 && (
                    <div style={{ marginBottom: 16 }}>
                      <div style={{ fontSize: 11, fontWeight: 700, color: "#555", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 8 }}>
                        My Top Used Actors
                      </div>
                      {topActorAndMovie.actors.map((a, i) => (
                        <RankRow key={a.name} rank={i + 1} name={a.name} image={a.image} isActor />
                      ))}
                    </div>
                  )}
                  {topActorAndMovie.movies?.length > 0 && (
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 700, color: "#555", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 8 }}>
                        My Top Used Movies
                      </div>
                      {topActorAndMovie.movies.map((m, i) => (
                        <RankRow key={m.name} rank={i + 1} name={m.name} image={m.image} isActor={false} />
                      ))}
                    </div>
                  )}
                </>
              )}
            </>
          )}

          {tab === 1 && (
            <>
              <div style={{ marginBottom: 20 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#555", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 8 }}>
                  Top Used Actors
                </div>
                {universalStats == null ? (
                  <div style={{ color: "#aaa", fontSize: 12, padding: "8px 0" }}>Loading…</div>
                ) : universalStats.topActors.length > 0 ? (
                  universalStats.topActors.map((a, i) => (
                    <RankRow key={a.name} rank={i + 1} name={a.name} image={a.image} isActor />
                  ))
                ) : (
                  <div style={{ color: "#aaa", fontSize: 12, padding: "8px 0" }}>No data available</div>
                )}
              </div>

              <hr style={{ margin: "4px 0 16px", border: "none", borderTop: "1px solid #eee" }} />

              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#555", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 8 }}>
                  Top Used Movies
                </div>
                {universalStats == null ? (
                  <div style={{ color: "#aaa", fontSize: 12, padding: "8px 0" }}>Loading…</div>
                ) : universalStats.topMovies.length > 0 ? (
                  universalStats.topMovies.map((m, i) => (
                    <RankRow key={m.name} rank={i + 1} name={m.name} image={m.image} isActor={false} />
                  ))
                ) : (
                  <div style={{ color: "#aaa", fontSize: 12, padding: "8px 0" }}>No data available</div>
                )}
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
